import React from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

import { Forms } from 'modules/refund';
import classes from '../ApplicationView.module.scss';
import Button from 'components/Button';
import * as Fields from 'components/Fields';

interface Props {
  applicationId: number;
  id: number;
  level: number;
  type: string;
  onCancel: () => void;
}

const RefundForm = ({ applicationId, id, type, level, onCancel }: Props) => {
  const { t } = useTranslation();

  return (
    <Forms.NewRefund
      id={id}
      type={type}
      level={level}
      onSuccess={() => {
        toast.success(t('message_new_refund_success').toString());
        onCancel();
      }}
      onError={() => {
        toast.error(t('message_new_refund_error').toString());
      }}
    >
      {({ isSubmitting, values }) => (
        <div className={classes.wrapper}>
          <div className={classes.refundTitle}>{t('title_new_refund_modal', { id: applicationId })}</div>
          {type === 'INDIVIDUAL' && (
            <div className={classes.refundRow}>
              <Fields.Mask mask={'0000 0000 0000 0000'} name={'card_number'} label={t('card_number')} required />
              <Fields.Text
                name={'card_owner'}
                label={t('card_owner')}
                placeholder={t('placeholder_card_owner')}
                required
              />
            </div>
          )}
          <div className={classes.refundRow}>
            {type === 'INDIVIDUAL' ? (
              <Fields.Number
                name={'bank_transit_account'}
                label={t('refund.bank_transit_account')}
                placeholder={t('placeholder_bank_transit_account')}
                required
              />
            ) : (
              <Fields.Number
                name={'bank_account'}
                label={t('refund.bank_account')}
                placeholder={t('placeholder_bank_account')}
                required
              />
            )}
            <Fields.Mask mask={'000 000 000'} name={'bank_tin'} label={t('bank_tin')} required />
          </div>
          <div className={classes.refundRow}>
            <Fields.Mask mask={'00000'} name={'bank_mfo'} label={t('refund.bank_mfo')} required />
            <Fields.Phone name={'phone'} label={t('phone')} required />
          </div>
          {(level === 2 || level === 3) && (
            <div className={classes.refundRow}>
              <Fields.Region label={t('refund.review_region')} name={'review_region_id'} required />
              {level === 3 && !!values.review_region_id && (
                <Fields.SubRegion
                  label={t('refund.review_sub_region')}
                  name={'review_sub_region_id'}
                  regionId={+values.review_region_id}
                  required
                />
              )}
            </div>
          )}
          <Fields.Textarea name={'comment'} label={t('comment')} placeholder={t('placeholder_comment')} required />
          <div className={classes.appealButtons}>
            <Button variant={'red'} onClick={onCancel} size={'large'} block>
              {t('cancel')}
            </Button>
            <Button
              variant={'green'}
              htmlType={'submit'}
              size={'large'}
              isLoading={isSubmitting}
              disabled={isSubmitting}
              block
            >
              {t('save')}
            </Button>
          </div>
        </div>
      )}
    </Forms.NewRefund>
  );
};

export default RefundForm;
